import { createUseStyles } from 'react-jss'
import { LightTheme } from '../../../theme'

import { BannerCarouselItemStyle } from './banner-carousel-item.types'

export const useStyle = createUseStyles((theme: LightTheme) => ({
  bannerOverflow: {
    right: '55%',
    position: 'absolute',
    top: 0,
    bottom: 0,
    maxWidth: '40vw'
  },
  button: ({ isBigButton }: BannerCarouselItemStyle) => ({
    marginTop: 24,
    width: isBigButton ? 400 : 96
  }),
  container: {},
  text: {
    marginTop: 16
  },
  title: {
    marginTop: 0
  },
  mainText: {
    marginTop: 8
  },
  anchor: {
    textDecoration: 'none'
  },
  '@media screen and (min-width: 481px) and (max-width: 1223px)': {
    text: {
      maxWidth: '40vw'
    },
    mainText: {
      maxWidth: '40vw'
    },
    title: {
      maxWidth: '40vw'
    },
    button: ({ isBigButton }: BannerCarouselItemStyle) => ({
      maxWidth: isBigButton && '40vw'
    })
  },
  '@media screen and (max-width: 480px)': {
    image: {
      height: '75vh'
    },
    bannerOverflow: {
      background: theme.colors.bannerOverflowMobile,
      backdropFilter: 'blur(10px)',
      width: 'calc(100vw - 24px)',
      maxWidth: 'calc(100vw - 24px)',
      height: 'fit-content',
      right: 0,
      top: 'unset',
      padding: '20px 12px',
      justifyContent: 'flex-start'
    },
    anchor: {
      width: 'calc(100% - 24px)'
    },
    button: ({ isBigButton }: BannerCarouselItemStyle) => ({
      marginTop: 20,
      padding: '16px 0',
      width: isBigButton && 'calc(100vw - 24px)'
    })
  }
}))
